import { createAsyncThunk } from '@reduxjs/toolkit';
import { _creditForCaseToCase } from '@custom/Utils/constants/apiUrls';

export const editHospitalCaseCredit = createAsyncThunk(
  'editHospitalCaseCredit',
  async (payload: any, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(_creditForCaseToCase.editHospital, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response?.ok) {
        return rejectWithValue(`Failed to update modality price. Status code: ${response?.status}`);
      }

      return await response.json();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export default editHospitalCaseCredit;
